import { render, staticRenderFns } from "./AnnotationDetailsContainer.vue?vue&type=template&id=35cfbbdb&scoped=true"
import script from "./AnnotationDetailsContainer.vue?vue&type=script&lang=js"
export * from "./AnnotationDetailsContainer.vue?vue&type=script&lang=js"
import style0 from "./AnnotationDetailsContainer.vue?vue&type=style&index=0&id=35cfbbdb&prod&scoped=true&lang=css"
import style1 from "./AnnotationDetailsContainer.vue?vue&type=style&index=1&id=35cfbbdb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cfbbdb",
  null
  
)

export default component.exports